import React, { useState } from 'react';

import icons from './../../../icons.svg';
import ConfirmModal from '../modals/confirmModal';

const SlotCalibrationInstruction = ({
  shelf,
  slot,
  text,
  cabinet,
  t,
  onGoBack,
  onGoNext,
  buttonText,
  calibrationState = '',
}) => {
  const [openCacelConfirmModal, setOpenCancelConfirmModal] = useState(false);

  const handleCancel = () => {
    if (calibrationState && calibrationState === 'confirmSlotEmpty') {
      setOpenCancelConfirmModal(true);
    } else {
      onGoBack();
    }
  };
  return (
    <div className="calibration__instruction">
      {calibrationState && calibrationState === 'confirmSlotEmpty' && (
        <ConfirmModal
          isOpen={openCacelConfirmModal}
          close={confirm =>
            confirm ? onGoBack() : setOpenCancelConfirmModal(false)
          }
          message={t('common:cancelCalibration')}
          t={t}
        />
      )}
      <div className="calibration__return" onClick={() => handleCancel()}>
        <svg>
          <use xlinkHref={`${icons}#icon-close`}></use>
        </svg>
      </div>
      <div className="calibration__instruction-cabinet">{cabinet.name}</div>
      <div className="calibration__selected">
        <span className="calibration__selected-shelf">
          {t('common:shelf')}: {shelf}
        </span>
        <span className="calibration__selected-slot">
          {t('common:slot')}: {slot}
        </span>
      </div>
      <div className="calibration__instruction-text">{text}</div>
      <div className="calibration__instruction-confirm" onClick={onGoNext}>
        <svg className="planogram__slots-item-cube">
          <use xlinkHref={`${icons}#icon-checkmark-outline`}></use>
        </svg>
        <span>{buttonText}</span>
        <svg className="planogram__slots-item-cube">
          <use xlinkHref={`${icons}#icon-arrow-right`}></use>
        </svg>
      </div>
    </div>
  );
};

export default SlotCalibrationInstruction;
